import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {DecimalPipe} from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { CarSearchPartialComponent } from '../partials/car-search-partial.component';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-business-car-loan-details',
    templateUrl: 'business-car-loan-details.component.html',
    providers: [DecimalPipe],
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule, MatSelectModule, MatSelectModule, MatOptionModule, MatOptionModule, ValidationPartialComponent, CarSearchPartialComponent, MatInputModule, MatInputModule, MatCheckboxModule, MatCheckboxModule]
})
export class BusinessCarLoanDetailsComponent implements OnInit, OnChanges {
  @Input() public formGroup: UntypedFormGroup;
  carLoanPurposes: any;
  brokerageEnabled = true;
  originatorEnabled = true;

  constructor() {
  }

  ngOnInit() {
    this.onFormChanges();
  }

  ngOnChanges() {
    this.calculateSubtotal();
    this.calculateSubtotalAndFees();
    this.calculateBrokerage();
    this.calculateLoanAmount();
  }

  onFormChanges() {
    this.formGroup.get('carLoanAmtIncGst').valueChanges.subscribe(val => {
      console.debug('BusinessCarLoanDetailsComponent.carLoanAmtIncGst.valueChanges');
      this.calculateSubtotal();
    });

    this.formGroup.get('carLoanDeposit').valueChanges.subscribe(val => {
      console.debug('BusinessCarLoanDetailsComponent.carLoanDeposit.valueChanges');
      this.calculateSubtotal();
    });

    this.formGroup.get('carLoanOriginationFee').valueChanges.subscribe(val => {
      console.debug('BusinessCarLoanDetailsComponent.carLoanOriginationFee.valueChanges');
      this.calculateSubtotalAndFees();
    });

    this.formGroup.get('carLoanBrokerageAmount').valueChanges.subscribe(val => {
      console.debug('BusinessCarLoanDetailsComponent.carLoanBrokerageAmount.valueChanges');
      this.calculateLoanAmount();
      this.calculateBrokerage();
    });
  }

  toggleBrokerageFees() {
    if (this.brokerageEnabled) {
      this.formGroup.get('carLoanBrokeragePercent').patchValue(0);
      this.formGroup.get('carLoanBrokerageAmount').patchValue(0);
      this.formGroup.get('carLoanBrokeragePercent').disable();
      this.formGroup.get('carLoanBrokerageAmount').disable();
      this.brokerageEnabled = false;
    } else {
      this.formGroup.get('carLoanBrokeragePercent').enable();
      this.formGroup.get('carLoanBrokerageAmount').enable();
      this.brokerageEnabled = true;
    }
  }

  toggleOriginatorFee() {
    if (this.originatorEnabled) {
      this.formGroup.get('carLoanOriginationFee').patchValue(0);
      this.formGroup.get('carLoanOriginationFee').disable();
      this.originatorEnabled = false;
    } else {
      this.formGroup.get('carLoanOriginationFee').enable();
      this.originatorEnabled = true;
    }
  }

  calculateSubtotal() {
    this.formGroup.get('carLoanSubtotal').patchValue(this.formGroup.get('carLoanAmtIncGst').value - this.formGroup.get('carLoanDeposit').value);
    this.calculateSubtotalAndFees();
    this.calculateLoanAmount();
  }

  calculateSubtotalAndFees() {
    this.formGroup.get('carLoanSubtotalAndFees').patchValue(this.formGroup.get('carLoanSubtotal').value + this.formGroup.get('carLoanApplicationFee').value + this.formGroup.get('carLoanOriginationFee').value);
    this.calculateLoanAmount();
  }

  calculateBrokerage() {
    const value = ((this.formGroup.get('carLoanBrokerageAmount').value / this.formGroup.get('carLoanSubtotal').value) * 100).toFixed(2);
    this.formGroup.get('carLoanBrokeragePercent').patchValue(value);
  }

  calculateLoanAmount() {
    this.formGroup.get('carLoanTotalAmount').patchValue(this.formGroup.get('carLoanSubtotalAndFees').value + this.formGroup.get('carLoanBrokerageAmount').value);
  }
}
